import {
  API_CATALOGO_PRODUTOS,
  API_CLIENTES,
  API_EXPEDICOES,
  API_ITENS_CARGA,
  API_MOVIMENTACOES_PRODUTOS,
  API_PEDIDOS_EXPEDICAO,
  API_PLANEJAMENTO_CARGAS,
  API_ESTOQUE_PRODUTOS,
  API_PRODUTOS_ETIQUETAS,
  API_CATEGORIAS_PRODUTO,
  API_ARMAZENS,
  API_DISPONIBILIDADE_SAIDA,
  API_PRODUTOS_COM_LOTE,
  API_LOTES_POR_PRODUTO,
  API_PRODUTOS,
} from '../api/apiConfig';
import {
  CategoriaProduto,
  Cliente,
  EstoqueProduto,
  ExpedicaoProduto,
  ItemCarga,
  MovimentacaoProduto,
  PedidoExpedicao,
  PlanejamentoCarga,
  ProdutoCatalogo,
  Armazem,
  DisponibilidadeSaidaItem,
  ProdutoComLote,
  LotesPorProdutoResponse,
} from '../types/estoque';
import { createCrudService, CrudService } from './crudFactory';
import http from '../api/http';

export const catalogoProdutosService =
  createCrudService<ProdutoCatalogo>(API_CATALOGO_PRODUTOS);
export const produtosService = createCrudService<ProdutoCatalogo>(API_PRODUTOS);
export const categoriasProdutoService =
  createCrudService<CategoriaProduto>(API_CATEGORIAS_PRODUTO);
export const clientesService = createCrudService<Cliente>(API_CLIENTES);
export const estoqueProdutosService =
  createCrudService<EstoqueProduto>(API_ESTOQUE_PRODUTOS);
export const produtosEtiquetasService = {
  list: (params?: Record<string, any>): Promise<{ results: EstoqueProduto[] }> =>
    http.get(API_PRODUTOS_ETIQUETAS, { params }).then((res) => res.data),
};
export const movimentacoesService =
  createCrudService<MovimentacaoProduto>(API_MOVIMENTACOES_PRODUTOS);
export const pedidosExpedicaoService =
  createCrudService<PedidoExpedicao>(API_PEDIDOS_EXPEDICAO);
export const expedicoesService = createCrudService<ExpedicaoProduto>(API_EXPEDICOES);
export const planejamentoCargasService =
  createCrudService<PlanejamentoCarga>(API_PLANEJAMENTO_CARGAS);
export const itensCargaService = createCrudService<ItemCarga>(API_ITENS_CARGA);
export const armazensService = createCrudService<Armazem>(API_ARMAZENS);

export const disponibilidadeSaidaService = {
  list: (params?: any): Promise<{ results: DisponibilidadeSaidaItem[] }> =>
    http.get(API_DISPONIBILIDADE_SAIDA, { params }).then((res) => res.data),
};

export const produtosComLoteService = {
  list: (params?: { q?: string }): Promise<ProdutoComLote[]> =>
    http.get(API_PRODUTOS_COM_LOTE, { params }).then((res) => res.data),
};

export const lotesPorProdutoService = {
  list: (params: { codigo?: string; produto_id?: number }): Promise<LotesPorProdutoResponse> =>
    http.get(API_LOTES_POR_PRODUTO, { params }).then((res) => res.data),
};
